import React from 'react';
import { Radio } from 'antd';
import styles from './template.module.scss';

const BroadcastTemplate = (props) => {
  return (
    <div className={styles.container}>
      <Radio.Group
        className={styles.RadioGroup}
        value={props.template}
        onChange={(e) => {
          props.setTemplate(e.target.value);
        }}
      >
        <Radio.Button value="one" className={styles.RadioGroupOne}>
          <div>模版一</div>
          <div className={styles.templateOne} />
        </Radio.Button>
        <Radio.Button value="two" className={styles.RadioGroupOne}>
          <div>模版二</div>
          <div className={styles.templateContent}>
            <div className={styles.templateTwo} />
            <div className={styles.templateTwo} />
          </div>
        </Radio.Button>
        <Radio.Button value="three" className={styles.RadioGroupOne}>
          <div>模版三</div>
          <div className={styles.templateThreeTop} />
          <div className={styles.templateThreeBottom} />
        </Radio.Button>
        <Radio.Button value="four" className={styles.RadioGroupOne}>
          <div>模版四</div>
          <div className={styles.templateContent}>
            <div className={styles.templateFourTop} />
            <div className={styles.templateFourTop} />
          </div>
          <div className={styles.templateFourBottom} />
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default BroadcastTemplate;
